import React, { useState, useEffect, useMemo } from "react";
import {
  OutlinedInput,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Checkbox,
  Box,
  InputAdornment,
  IconButton,
  TextField,
  ListSubheader,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setState } from "../analyzeSlice";
import InfiniteScroll from "react-infinite-scroller";
import { FilterRounded } from "@mui/icons-material";

const MultiSelectSKUFilter = (props) => {
  const dispatch = useDispatch();
  const columnData = props?.getSKUData;
  //const [columns, setColumns] = useState([]);
  const columns = [
    ...new Set(columnData.map((item) => item.skuName)),
  ];
  const state = useSelector((store) => store.analyze);
  const {
    selectedScnarioFilter,
    selectedCustomerFilter,
  } = state;

  const [columnName, setcolumnName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(columns.length);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const itemsPerPage = 200;
  const [hasMore, setHasMore] = useState(true);
  const [records, setrecords] = useState(itemsPerPage);

  const memoizedFilteredColumns = useMemo(() => {
    let filteredColumns = columnData;

    if (selectedCustomerFilter.length > 0) {
      filteredColumns = filteredColumns.filter((item) =>
        selectedCustomerFilter.includes(item.customerName)
      );
    }

    if (selectedScnarioFilter.length > 0) {
      filteredColumns = filteredColumns.filter((item) =>
        selectedScnarioFilter.includes(item.scenarioName)
      );
    }

    return [...new Set(filteredColumns.map((item) => item.skuName))];
  }, [selectedCustomerFilter, selectedScnarioFilter, columnData]);

  useEffect(() => {
    setNamesData(memoizedFilteredColumns);
  }, [memoizedFilteredColumns]);

  useEffect(() => {
    if(selectedScnarioFilter.length === 0){
      setcolumnName([]);
    }
  },[selectedScnarioFilter])

  const loadMore = () => {
    if (records === columns.length) {
      setHasMore(false);
    } else {
      setTimeout(() => {
        setrecords(records + itemsPerPage);
      }, 2000);
    }
  };

  const handleChange = (e, name) => {
    let items = [...columnName];

    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }

    setcolumnName(items);

    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount == 0) setSelectAll(false);
    if (itemcount == columns.length) setSelectAll(true);
    else setSelectAll(false);
  };

  useEffect(() => {
    // Clear search text value
    setNamesData(columns);
    setSelectedOptions([]);
    setcolumnName([]);
  }, [columnData]);

  const handleDelete = (e) => {
    e.preventDefault();
    setcolumnName([]);
  };

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      if (searchText) {
        let val = columns.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...columnName, ...val];
        const distinctArray = [...new Set(item)];
        setcolumnName(distinctArray);
        let itemcount = distinctArray.length;
        setDisplayItem(itemcount);
      } else {
        setcolumnName(columns);
        let itemcount = columns.length;
        setDisplayItem(itemcount);
      }
    } else {
      if (searchText) {
        let val = columns.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...columnName];
        item = item.filter((name) => !val.includes(name));
        const distinctArray = [...new Set(item)];
        setcolumnName(distinctArray);

        let itemcount = distinctArray.length;
        setDisplayItem(itemcount);
      } else {
        setcolumnName([]);
        dispatch(setState("selectedSKUDesFilter", []));
      }
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !columnName.includes(name));
    if (item.length == 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [namesData]);

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = columns.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          return val;
        });
      } else {
        setSearchText();
        setNamesData(columns);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  useEffect(() => {
    dispatch(setState("selectedSKUDesFilter", columnName));
  }, [columnName]);

  return (
    <div>
      {columns.length > 0 && (
        <InfiniteScroll
          pageStart={0}
          loadMore={loadMore}
          hasMore={hasMore}
          useWindow={false}
        >
          <FormControl>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              //fullWidth
              sx={{
                width: 300,
                height: "38px !important",
                mt: "-10px !important",
              }}
              value={columnName}
              // onChange={handleChange}
              size="small"
              input={<OutlinedInput label="MultiSelect" />}
              renderValue={(selected) => (
                <Box
                  sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
                  MenuProps
                >
                  <div>
                    <span>+ {displayItem}</span>
                    <span>
                      <CancelIcon
                        sx={{
                          paddingLeft: "25px",
                          top: "20%",
                          position: "absolute",
                        }}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                        onClick={(e) => handleDelete(e)}
                      />
                    </span>
                  </div>
                </Box>
              )}
            >
              <MenuItem onClick={handleSelectAll}>
                <Checkbox checked={selectAll} />
                <ListItemText primary="Select All" />
              </MenuItem>
              <ListSubheader>
                <TextField
                  size="small"
                  inputRef={textInput}
                  placeholder=""
                  //fullWidth
                  value={searchText}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      /*close icon to clear the search text*/
                      <InputAdornment position="end">
                        <IconButton onClick={() => setSearchText("")}>
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => handleInputChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                      // Prevents autoselecting item while typing (default Select behaviour)
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
              {namesData.slice(0, records).map((name, index) => (
                <MenuItem key={index + name} value={name}>
                  {selectAll ? (
                    <Checkbox
                      onChange={(e) => handleChange(e, name)}
                      checked={columnName.some((o) => o === name)}
                    />
                  ) : (
                    <Checkbox
                      onChange={(e) => handleChange(e, name)}
                      checked={columnName.indexOf(name) > -1}
                    />
                  )}
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default MultiSelectSKUFilter;
